import ChangesTimeline from "../ChangesTimeline";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MDBox from "components/MDBox";

export default function ChangesDialog({
    docId,
    docType,
    title,
    open,
    onClose,
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
        >
            <DialogTitle sx={{ m: 0 }}>
                <MDBox display="flex" alignItems="center" justifyContent="space-between">
                    <MDBox>
                        {title}
                    </MDBox>
                    <MDBox>
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{ color: (theme) => theme.palette.grey[500], }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </MDBox>
                </MDBox>
            </DialogTitle>
            <DialogContent>
                <ChangesTimeline
                    docId={docId}
                    docType={docType}
                />
            </DialogContent>
        </Dialog>
    )
}